import { createPromise } from "common/promises/create";
import * as PIXI from "pixi.js";
export const sprite = {
    loadTexture,
    fromTexture,
};
async function loadTexture(imagePath) {
    const texture = PIXI.Texture.from(imagePath);
    const { promise, resolve } = await createPromise();
    console.log(`Load ${imagePath}`);
    texture.baseTexture.once("loaded", () => resolve(texture));
    if (texture.valid) {
        console.log(`Already loaded ${imagePath}`);
        return texture;
    }
    await promise;
    console.log(`Loaded  ${imagePath}`);
    return texture;
}
function fromTexture(texture) {
    const sprite = new PIXI.Sprite(texture);
    sprite.anchor.set(0.5, 0.5);
    return sprite;
}
//# sourceMappingURL=sprite.js.map